import React from 'react'
import AITestContext from '../../../contexts/AITestContext'
import LanguageIcon from '@mui/icons-material/Language';
import './aitest.css'


export const TestLanguage = ({language}) => {

  const {
    //language,
    setShowTestLanguages, 
    collegetestmode, 
  } = React.useContext(AITestContext);

const onShowLanguages = () => {
  if (collegetestmode)
    return
  setShowTestLanguages(true)
}
  return (
      <div>
          <div style = {{marginTop:'10px', marginBottom:'20px', color:'maroon'}}>
                <LanguageIcon  onClick={onShowLanguages}/>
                <label className='navbarFonts' style={{paddingLeft: '5px', fontWeight:'bold'}}><span style = {{fontSize:'20px'}}>{language}</span></label>
          </div>
   
      </div>
    )
  }
